/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-24 11:13:42
 * @LastEditTime: 2025-04-10 15:14:17
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\information\index.tsx
 * @Description: 学校招生查询
 */
import LabelNone from "@/components/label_none";
import { CommmonGet } from "@/util/network/api";
import { Input, Spin } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { LgPaginationA } from "lancoo-web-ui";

const pageSizeList = [
    { text: "每页10条", Info: 10 },
    { text: "每页20条", Info: 20 },
    { text: "每页30条", Info: 30 },
];

const Materials = () => {
    const service = {
        list: "/portal/homepage/getInformation",
        countViews: "/portal/homepage/countViews",
    };
    const { pathname } = useLocation();
    const navigate = useNavigate();

    // 刷新
    const [isloading, setIsloading] = useState<boolean>(false);
    const [onceload, setOnceload] = useState<boolean>(false);
    // 表格
    const [list, setList] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const getInit = (curPageNum = 1, curPageSize = 10) => {
        setIsloading(true);
        CommmonGet(service.list, {
            pageIndex: curPageNum,
            pageSize: curPageSize,
        }, 60000).then((res: any) => {
            setList(res.data?.pageList || []);
            setTotal(res.data.total);
        }).catch(() => { }).finally(() => {
            setIsloading(false);
            setOnceload(true);
        });
    };

    const handleIndex = (item) => {
        // 在跳转前设置标记
        sessionStorage.setItem('fromNavigate', 'true');
        navigate(`/information/details?infoId=${item.infoId}`);
    };

    useEffect(() => {
        pathname === "/information" && getInit(pageNum, pageSize);
    }, [pathname]);

    const getInfoType = (type: number) => {
        if (type === 1) return "招生政策"
        if (type === 2) return "招生简章"
        if (type === 3) return "学位动态"
        return '其他资讯'
    }

    return (
        <>
            {pathname === "/information" && (
                <div className="information">
                    <Spin spinning={isloading} className="wjz_spin_div">
                        {onceload ?
                            list?.length !== 0 ? (
                                <>
                                    {list.map((ele, index) => {
                                        return (
                                            <div
                                                className="lately-item"
                                                key={ele.infoId || index}
                                                onClick={() => handleIndex(ele)}
                                            >
                                                <div className="title1 left">
                                                    <div
                                                        className="coverimg"
                                                        style={{
                                                            backgroundImage: `url(${ele?.coverImage?.preUrl || ""
                                                                })`,
                                                        }}
                                                    />
                                                    <div className="moremsg">
                                                        <div className="title">
                                                            <span className="titleInner">{ele.infoTitle}</span>
                                                            {ele.top == 1 && <i />}
                                                        </div>
                                                        <div className="content">
                                                            <div className="text">
                                                                {ele?.infoAbstract ?? ''}
                                                            </div>
                                                            <div>
                                                                <span style={{ color: '#ff6600' }}>{getInfoType(ele.infoType)}</span>
                                                                <span className="spit"></span>
                                                                <span>{ele.releaseTime}</span>
                                                                <span className="spit"></span>
                                                                <span>{ele.times || 0}次浏览</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div className="information_pagination">
                                        {
                                            total > pageSizeList[0].Info && <LgPaginationA
                                                total={Math.ceil(total / pageSize)}
                                                size="normal"
                                                currentPage={pageNum}
                                                onChangePage={(v) => {
                                                    setPageNum(v);
                                                    getInit(v, pageSize);
                                                }}
                                                pageSizeList={pageSizeList}
                                                pageSizeIndex={0}
                                                pageSizeSelect={(v) => {
                                                    const index = v.Info;
                                                    setPageSize(index);
                                                    setPageNum(1);
                                                    getInit(1, index);
                                                }}
                                                pageSizePosition={"top"}
                                            />
                                        }

                                    </div>
                                </>
                            ) : <LabelNone tips="暂无招生资讯" search={false} />
                            : <div></div>
                        }
                    </Spin>
                </div>
            )}
            <Outlet />
        </>
    );
};

export default Materials;
